module.exports = __webpack_public_path__ + "static/media/pg_quiz_ph.f13d1c77.jpg";